import { VenuesResultsView } from "../../../components/views/VenuesResultsView"

export default function CityIndex(props) {
  // console.log("CityIndex", props.venues?.length, props.category)
  const venues = props.venues
  const loading = props.loading ?? false

  return VenuesResultsView({
    venues,
    loading: loading,
    stats: props.stats,
    city: props.city,
    category: props.category,
    subcategory: props.subcategory,
    page: 1,
    pathPrefix: props.path,
    pageMeta: props.pageMeta,
  })
}

export async function getStaticProps({ params, ...others }) {
  // params contains the post `id`.
  // If the route is like /posts/1, then params.id is 1
  const resolvedUrl = `/${params.category}/${params.subcategory}`
  console.log("Get getStaticProps", params, others, resolvedUrl)

  const url = process.env.NEXT_PUBLIC_API_URL + `/page?url=${resolvedUrl}`
  console.log("get Page getStaticProps.", url)
  let pageData = {}
  try {
    var data = await fetch(url).then((res) => res.json())
    console.log("Got page data")
    if (data) {
      pageData = data
    }
  } catch (err) {
    console.log("Error fetching venue: ", err)
  }

  return {
    props: { ...pageData, path: resolvedUrl },
    revalidate: 60,
  }
}

export async function getStaticPaths(params, params2) {
  console.log("CitiPage.getStaticPaths", params, params2)
  var paths = []
  // add categores
  var categories = [
    "inne",
    "warsztaty-stacjonarne",
    "gotowanie",
    "eksperymenty",
    "lego",
    "robotyka",
    "plastyka",
    "sportowe",
    "gastronomia",
    "restauracje",
    "kawiarnie",
    "restauracje-z-ogrodem",
    "sale-zabaw",
    "baseny",
    "trampoliny",
    "escape-room",
    "scianki",
    "rozrywka",
    "gry-vr",
    "kawiarnie-z-ogrodem",
    "uslugi",
    "polkolonie",
    "fotograf",
    "cukiernie",
    "catering",
    "animacje",
    "magiczne",
    "foto-budka",
  ]

  // paths = [
  //   ...paths,
  //   ...categories.map((c) => ({
  //     params: { category: "kategoria", subcategory: c },
  //   })),
  // ]

  return { paths, fallback: true }
}
